import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, { parseFractionLikeInput } from "../../../../components/inputs/FractionInput"
import { formatLatexPreview } from "../../../../components/inputs/FractionInput"
import { formatFractionLatexCore } from "../../../../components/inputs/FractionInput";

// ==== FORMATOWANIE FRAKCJI ====

function formatFraction(numerator, denominator) {
  const gcd = (a, b) => {
  if (!Number.isFinite(a) || !Number.isFinite(b)) return 1;
  return b === 0 ? Math.abs(a) : gcd(b, a % b);
};

  const sign = Math.sign(numerator) * Math.sign(denominator);
  const absNum = Math.abs(numerator);
  const absDen = Math.abs(denominator);
  const d = gcd(absNum, absDen);

  const simpNum = absNum / d;
  const simpDen = absDen / d;

  if (simpNum % simpDen === 0) {
    // Całkowita
    return `${sign * (simpNum / simpDen)}`;
  }

  const whole = Math.floor(simpNum / simpDen);
  const remainder = simpNum % simpDen;

  if (whole === 0) {
    // Czysty ułamek, np. -3/5
    return `${sign < 0 ? "-" : ""}\\dfrac{${simpNum}}{${simpDen}}`;
  }

  // Mieszany, np. -1 1/3
  return `${sign < 0 ? "-" : ""}${whole}\\dfrac{${remainder}}{${simpDen}}`;
}


// ==== GENERATOR ====

export function generateTask() {
  const rand = () => Math.floor(Math.random() * 17) - 8;
  let x1, y1, x2, y2;

  do {
    x1 = rand();
    y1 = rand();
    x2 = rand();
    y2 = rand();
  } while (x1 === x2); // unikamy dzielenia przez 0

  const dx = x2 - x1;
  const dy = y2 - y1;

  return {
    type: "FindSlopeTask",
    data: {
      x1, y1, x2, y2,
      slope: { numerator: dy, denominator: dx }
    }
  };
}

// ==== RENDER ====

export function renderTask({ data }) {
  const { x1, y1, x2, y2 } = data;
  return (
    <>
      <p>Oblicz współczynnik kierunkowy <InlineMath math="a" /> prostej przechodzącej przez punkty:</p>
      <p>
        <InlineMath math={`A=(${x1},${y1})`} />,{" "}
        <InlineMath math={`B=(${x2},${y2})`} />
      </p>
    </>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = userAnswer.parsed;
  const expected = data.slope.numerator / data.slope.denominator;
  if (given === null) return false;
  return Math.abs(expected - given) < 0.01;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={formatLatexPreview(userAnswer.raw)} />;
}


export function renderAnswer({ data }) {
  const { numerator, denominator } = data.slope;

  const gcd = (a, b) => {
  if (!Number.isFinite(a) || !Number.isFinite(b)) return 1;
  return b === 0 ? Math.abs(a) : gcd(b, a % b);
};
  const d = gcd(numerator, denominator);
  const simpNum = numerator / d;
  const simpDen = denominator / d;

  return <InlineMath math={`a = ${formatFraction(simpNum, simpDen)}`} />;
}


export function renderExplanation({ data }) {
  const { x1, y1, x2, y2 } = data;
  const dx = x2 - x1;
  const dy = y2 - y1;
  const fs = (v) => (v < 0 ? `(${v})` : v);

  const gcd = (a, b) => {
  if (!Number.isFinite(a) || !Number.isFinite(b)) return 1;
  return b === 0 ? Math.abs(a) : gcd(b, a % b);
};
  const d = gcd(dy, dx);
  const simpNum = dy / d;
  const simpDen = dx / d;

  return (
    <div className="space-y-2">
      <p><strong>Krok 1:</strong> Korzystamy ze wzoru na współczynnik kierunkowy (z karty wzorów):</p>
      <BlockMath math="a = \dfrac{y_B - y_A}{x_B - x_A}" />

      <p><strong>Krok 2:</strong> Podstawiamy dane i obliczamy różnice:</p>
      <BlockMath math={`a = \\dfrac{${fs(y2)} - ${fs(y1)}}{${fs(x2)} - ${fs(x1)}} = \\dfrac{${dy}}{${dx}}`} />

      <p><strong>Krok 3:</strong> Upraszczamy ułamek:</p>
      <BlockMath math={`a = ${formatFraction(simpNum, simpDen)}`} />
    </div>
  );
}


